<template>
    <div>
        <b-button variant="primary" @click="actionsModal.show = true">{{ $t('edit') }}</b-button>

        <main-dialog title="Edit actions" v-model="actionsModal.show">
            <span v-if="actions.length < 1">{{ $t('noActions') }}</span>
            <b-list-group>
                <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="action in actions" button v-bind:key="action.name" @click="actionEdit(action)"> {{ action.name }}  <i class="fa fa-eye fa-lg" v-if="action.display_condition !== ''"></i></b-list-group-item>
            </b-list-group>
             <template v-slot:modal-footer>
                <b-button variant="primary" @click="create">{{ $t('create') }}</b-button>
            </template>
        </main-dialog>

        <main-dialog size="lg" title="Action" v-model="actionEditModal.show" hide->
            <InputField type="text" name="name" :label="this.$t('name')" v-model.number="actionEditModal.data.name" @error="fieldError"
                :rules="{required: true, length: {min: 2, max: 25}}"
            />

                <CodeEditor
                    v-model="actionEditModal.data.display_condition"
                    editor_description="Expression should return boolean. Ex: if you want button to be displayed return true"
                    :label="this.$t('displayCondition')"
                    :label-cols="2"
                    :horizontal="true"
                    :libs="displayCondLibs"
                    :vars="actionVars"
                />


                <b-form-group
                    :description="this.$t('defineFields')"
                    :label="this.$t('fields')"
                    :label-cols="2"
                    :horizontal="true">
                    <b-button variant="primary" @click="editField = true"> {{ $t('edit') }} </b-button>
                </b-form-group>

                <main-dialog title="Fields" v-model="editField" hide-footer size="lg">
                    <Fields v-model="actionEditModal.data.fields" :config="fieldsConfig"/>
                </main-dialog>

                <CodeEditor
                    v-model="actionEditModal.data.action"
                    editor_description="You can modify model here, when users click on action in create/edit page this logic will be performed"
                    :label="this.$t('action')"
                    :label-cols="2"
                    :horizontal="true"
                    :libs="actionLibs"
                    :vars="actionVars"
                />

            <template v-slot:modal-footer>
                <b-button variant="danger" @click="remove" v-if="!actionEditModal.create">{{ $t('remove') }}</b-button>
                <b-button variant="success" @click="save">{{ $t('save') }}</b-button>
            </template>
        </main-dialog>
    </div>
</template>

<script>
import InputField from '@/components/form/Input'
import CodeEditor from '@/components/form/Editor/Code'

export default {
    components: {
        InputField,
        CodeEditor,
        Fields: () => import("../../base/Settings/Fields")
    },
    props: {
       value: {
         type: Array
       },
       uuid: {
         type: String
       }
    },
    computed: {
        actionVars() {
            return [
                {
                    name: "model",
                    usage: this.modelFields()
                },
                {
                    name: "input",
                    usage: this.actionFields()
                }
            ]
        } ,

        displayCondLibs() {
            return  [
                {
                    name: "Lodash",
                    varName: "_",
                    docs: "https://lodash.com/"
                },
            ]
        },

        actionLibs() {
            return [
                {
                    name: "Lodash",
                    varName: "_",
                    docs: "https://lodash.com/"
                },
                {
                    name: "protokol/model",
                    varName: "model",
                    docs: this.$env.get('DOCS_URL') + "/docs#libs-context"
                },
                {
                    name: "moment",
                    varName: "moment",
                    docs: "https://momentjs.com/"
                },
                {
                    name: "protokol/resource",
                    varName: "resource",
                    docs: this.$env.get('DOCS_URL') + "/docs#libs-resource"
                },
                {
                    name: "protokol/workflow",
                    varName: "workflow",
                    docs: this.$env.get('DOCS_URL') + "/docs#libs-workflow"
                }
            ]
        }
    },
    methods: {
        create() {
            this.actionEditModal.show = true;
            this.actionEditModal.create = true;

            this.actionEditModal.data = {
                name: '',
                action: '',
                display_condition: ''
            };
        },

        remove() {
            this.actions = this.actions.filter(a => {
                return a.name != this.actionEditModal.data.name;
            })

            this.actionEditModal.show = false;

            this.$emit('input', this.actions);
        },

        save() {
            if (this.checkForErrors()) {
                this.$mainDialog.msgBoxOk(this.$t('invalidFields'));
                return;
            }

            this.actionEditModal.show = false;

            if (this.actionEditModal.create) {
                this.actions.push(this.actionEditModal.data);
            }

            this.$emit('input', this.actions)

            this.actionEditModal.data = {
                name: '',
                action: ''
            };
        },

        actionEdit(action) {
            this.actionEditModal.show = true;
            this.actionEditModal.create = false;
            this.actionEditModal.data = action;
        },

        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors() {
            return this.errors.find((i, e) => {
                return i.error
            })
        },

        modelFields() {
            let componentUuid = this.uuid

            let component = this.$store.getters.componentSettings(componentUuid)
            let fields = component.settings.fields

            let formated = {}

            if (fields !== null) {
                fields.forEach(f => {
                    formated[f.key] = null

                    if (f.module == "input" || f.module == "textarea") {
                        formated[f.key] = ""

                        if (f.type == "number") {
                            formated[f.key] = 0
                        }
                    }
                })
            }

            return JSON.stringify(formated)
        },

        actionFields() {
            let fields = this.actionEditModal.data.fields || []

            let formated = {}

            if (fields !== null) {
                fields.forEach(f => {
                    formated[f.key] = null

                    if (f.module == "input" || f.module == "textarea") {
                        formated[f.key] = ""

                        if (f.type == "number") {
                            formated[f.key] = 0
                        }
                    }
                })
            }

            return JSON.stringify(formated)
        }
    },
    data: function() {
        return {
            errors: [],
            actions: this.value || [],
            actionsModal: {
                show: false
            },
            actionEditModal: {
                create: false,
                show: false,
                data: {
                    name: '',
                    action: '',
                    display_condition: ''
                }
            },
            editField: false,
            fieldsConfig: {
                fieldDefs: {
                    modules: {
                        input: ["text", "number", "date", "email"],
                        select: ["text", "number", "relation"],
                        radio: ["text", "number"],
                        checkbox: ["text", "number", "bool"],
                        picker: ["date", "daterange", "datetime", "time"]
                    }
                },
                hideGroup: true,
                hideProtected: true,
                hideVisible: true,
                fieldSize: 6
            }
        }
    },

    mounted() {
        this.modelFields()
    }
}
</script>
